import { ApiHttpService } from '../ApiHttpService';

import { FAQInfoMainSectionSerializer } from '../serializers/FAQInfoMainSectionSerializer';
import { FAQInfoMainSection } from '../../models/FAQInfoMainSection';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const FAQ_INFO_PATH = 'Parametros/Informacion';

class FAQInfoController {
  static async all() {
    const queryParams = ParamsHelper.createQueryParams({
      tipoInformacion: 2,
    });
    const response = await ApiHttpService.get(`${FAQ_INFO_PATH}${queryParams}`);
    const mainSectionsResponse = (response.data || {}).mainsections || [];
    const deSerializedData = mainSectionsResponse.map(FAQInfoMainSectionSerializer.deSerialize);
    return deSerializedData.map(data => new FAQInfoMainSection(data));
  }
}

export { FAQInfoController };



// WEBPACK FOOTER //
// ./src/networking/controllers/FAQInfoController.js